import { render, staticRenderFns } from "./CardFeedbacks.vue?vue&type=template&id=00d1874e&scoped=true&"
import script from "./CardFeedbacks.vue?vue&type=script&lang=js&"
export * from "./CardFeedbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1874e",
  null
  
)

export default component.exports